<script>
/**
 * @overview 商品中心 - 课程管理 - 课时管理
 *
 * @author suyanping

 * 参考:
  https://final-admin-vue.caihonggou.com/curriculum-period/420
  仓库: saas.final.vue

  列表数据
  /api/course/commodities/courses
 */
import Draggable from "vuedraggable";
import errorHandler from "@/components/AppFormAlert/errorHandler";
import axios from 'axios';
import TypeSelect from '../components/typeSelect2';

export default {
  name: "CurriculumPeriod",

  components: {
    Draggable,
    TypeSelect,
  },
  inject: ['reload'],
  data() {
    return {
      loading: false,
      selectLocalId: '',
      visibleLocal: false,
      course_id: '',
      likeName: '',
      id: this.$route.query.id,

      formData: {
        show: true,
        loading: false,
        name: "",
        introduction: "",
        category: "",
        course_count: "",
        content: []
      },

      currCourseName: "",

      courseData: {},

      courseForm: {
        id: null,
        course_id: null,
        structure_id: null,
        subject_id: null,
        sort: null,
        type: null
      },

      courseRules: {
        course_id: [this.$rules.required("课时", "number")]
      },

      courseId: null,

      subjectId: null,

      subjectList: [],

      subjects: [],

      structureList: [],

      treeProps: {
        label: "name",
        children: "leaf"
      },

      visible: false,
      visibleRecord: false,

      isCheck: null,

      structureId: null,

      current_page: 1,

      current_size: 10,

      total: 0,

      columnsLocal:[
        { prop: "id", label: "文件号ID" },
        { prop: "type_text", label: "文件号" },
         { prop: "status_text", label: "状态" },
        {
          prop: "user.realname",
          label: "直播间名称"
        },
        {
          prop: "user.name",
          label: "直播间账号"
        },
        {
          prop: "course_resource.video_url",
          label: "后景视频"
        }
      ],

      columnsRecord: [
        {
          prop: "studio_name",
          label: "直播老师"
        },
        {
          prop: "schedule_id",
          label: "课表ID"
        },
        {
          prop: "curriculum_name",
          label: "课程名称"
        },
        {
          prop: "sort",
          label: "课时进度"
        },
        {
          prop: "course_name",
          label: "课时名称"
        },
        {
          prop: "course_title",
          label: "课时标题"
        },
        {
          prop: "date",
          label: "上课日期"
        },
        {
          prop: "start_time",
          label: "上课时间"
        },
        {
          prop: "url",
          label: "视频链接"
        }
        // {
        //   prop: "json1",
        //   label: "配置表"
        // },
        // {
        //   prop: "json",
        //   label: "时间线"
        // }
      ],
      curCourseRecordIndex: 0,
      //查询录播课列表的  course_id
      curCourseId: "",
      list:{
        data:[]
      },
      local:{
        recording_list_id: '',
        type:''
      },

      typeSelectDataMe: [
        {
          id: 0,
          name: '所有分类',
          delete: true
        }
      ],
      typeSelectData: {},
      moves: {
        show: false,
        data: [],
        options: [],
        isSubmit: false,
        form: [],
      },

      cacheId: '',
      cacheSelect: {},
      cacheIds: [],
    };
  },

  created() {
    let _data = this.$store.state.editClassData,
      _back = this.$store.state.editClassBack;

    let ax_a,
        ax_b,
        ax_c;

    this.loading = true;

    // 编辑
    if (_back.status) {
      const _storage = sessionStorage.getItem('editClassList'),
        _arr = _storage ? JSON.parse(_storage) : [];

      if (_back.status === 2) {
        _arr.splice(parseInt(sessionStorage.getItem('editClassSplice')), 0, ..._data);
        _data = _arr;
      } else  {
        _data = _arr.concat(_data);
      }

      this.$store.commit('getEditClassBack', {});
    }
    sessionStorage.removeItem('editClassList');

    if (_data.length) {
      ax_c = this.$http.put(`/api/course/commodities/courses`, _data).then(res => {
        ax_a = this.getCourseInfo();
        ax_b = this.getCourseList();
        this.$store.commit('getEditClassData', []);
      })

      axios.all([ax_a, ax_b, ax_c]).finally(() => {
        this.loading = false;
      });
    } else {
      ax_a = this.getCourseInfo();
      ax_b = this.getCourseList();

      axios.all([ax_a, ax_b]).finally(() => {
        this.loading = false;
      });
    }
  },
  computed: {
    //监听当前的选中的值
    selectRecordId: {
      get() {
        return this.courseData.data[this.curCourseRecordIndex]
          .currentSelectRecordId;
      },
      set(newValue) {
        this.courseData.data[
          this.curCourseRecordIndex
        ].currentSelectRecordId = newValue;
        let temp = this.courseData.data[this.curCourseRecordIndex];
        this.$set(this.courseData.data, this.curCourseRecordIndex, temp);
      }
    },

    nodeObj () {
      const obj = {
        isEdit: this.isEdit,
        data: this.addTypeNode
      }
      return obj
    },
  },

  methods: {
    submitLocal(){
      this.selectRecordId = ''
      this.$message.success("选择成功")
      this.visibleLocal =false
    },
    cancelLocal(){
      this.visibleLocal =false
      this.local={}
    },
    choiceRadio(val){
      this.local.recording_list_id = val
      this.local.type = 3
    },
    choiceLive(){
      this.getCourseData()
    },
    // 本地化接口
    choiceLocal(){
      const url = `/course/${this.course_id}/recording?page=${this.current_page}&per_page=${
        this.current_size
      }`;
      this.$http.get(url).then(res=>{
         this.courseData = res;
      })
    },
    selectSubject(){
      this.getCourseData()
    },
    videoUrl(event){
     event.stopPropagation();
    },

    checkPermission(key, text) {
      return true
      // return this.$permissions(`curriculum_center.curriculum.${key}`, text);
    },

    getCourseInfo () {
      return this.$http.get(`/api/course/commodities/${this.id}`).then(res => {
        const _data = res.data;

        this.typeSelectData = {
          id: this.id,
          tree: _data.category_tree || [],
          old: _data.category_ids || [],
        };

        this.formData.name = _data.name;
        this.formData.introduction = _data.introduction;
        this.formData.category = _data.category;
        this.formData.course_count = _data.course_count;
      });
    },

    getCourseList(callback) {
      this.formData.loading = true;

      const _http = this.$http.get(`/api/course/commodities/courses?equal[commodities_id]=${this.id}&order[sort]=asc&per_page=9999`).then(res => {
        const _content = [];

        res.items.forEach(res => {
          res.commoditable.liveroom_course_type = res.liveroom_course_type;
          res.commoditable.ids = res.id;
          res.commoditable.category_ids = res.category_ids;
          _content.push(res.commoditable);
        });

        this.formData.content = _content;
        callback && callback();
      }).finally(() => {
        this.formData.loading = false;
      });

      return _http;
    },

    dragCourseware({ oldIndex, newIndex }) {
      const oldData = Object.assign([], this.formData.content),
        _id = this.id,
        newData = [];

      if (oldIndex === newIndex || newIndex === oldData.length || oldIndex === oldData.length) return;

      this.formData.loading = true;

      oldData.forEach(val => {
        newData.push({
          commodities_id: _id,
          commoditable_id: val.id,
          liveroom_course_type: val.liveroom_course_type,
        });
      });

      const oldValue = newData[oldIndex],
        newValue = newData[newIndex];

      newData[oldIndex] = newValue;
      newData[newIndex] = oldValue;
       console.log('newData', newData)
      this.$http.put(`/api/course/commodities/courses`, newData).then(() => {
        const newItem = this.formData.content[newIndex];
        const oldItem = this.formData.content[oldIndex];

        this.formData.content.splice(newIndex, 1, oldItem);
        this.formData.content.splice(oldIndex, 1, newItem);

        this.updateFormData();
      }).catch(error => {
        const errorMessage = errorHandler(error);

        this.$message.error(errorMessage[0]);
      }).finally(() => {
        this.formData.loading = false;
      });
    },

    delCourse(id) {
      this.$confirm("确定删除该课时？", "删除确认", {
        showCancelButton: true,
        type: "warning",
        confirmButtonText: "删除",
        confirmButtonClass: "el-button--danger"
      })
      .then(() => this.sureDeleteCourse(id))
      .catch(() => {})
    },

    sureDeleteCourse(id) {
      const oldData = Object.assign([], this.formData.content),
        _id = this.id,
        newData = [];

      for (let i = 0; i < oldData.length; i++) {
        if (oldData[i].id === id) {
          oldData.splice(i, 1);
          break;
        }
      }
      oldData.forEach(val => {
        newData.push({
          commodities_id: _id,
          commoditable_id: val.id,
          liveroom_course_type: val.liveroom_course_type,
        })
      })

      this.$http.put(`/api/course/commodities/courses`, newData).then(() => {
        this.getCourseList();
      });
      // this.$http
      //   .delete(`/curriculum/course/${id}`)
      //   .then(() => {
      //     this.getCourseList();
      //
      //     this.$alert("删除成功", "删除确认", {
      //       confirmButtonText: "我知道了",
      //       type: "success",
      //       confirmButtonClass: "success"
      //     });
      //   })
      //   .catch(({ message }) => {
      //     this.$alert(message, "删除确认", {
      //       confirmButtonText: "我知道了",
      //       type: "warning",
      //       confirmButtonClass: "el-button--danger"
      //     });
      //   });
    },

    updateCourse(add, id) {
      if (!this.checkPermission("course_store")) return;
      const oldData = Object.assign([], this.formData.content),
        _id = this.id,
        newData = [];

      if (add) {
          oldData.forEach(val => {
            newData.push({
              commodities_id: _id,
              commoditable_id: val.id,
              liveroom_course_type: val.liveroom_course_type,
            })
          })
      } else {
        for (let i = 0; i < oldData.length; i++) {
          if (oldData[i].id === id) {
            sessionStorage.setItem('editClassSplice', i);
            oldData.splice(i, 1);
            break;
          }
        }

        oldData.forEach(val => {
          newData.push({
            commodities_id: _id,
            commoditable_id: val.id,
            liveroom_course_type: val.liveroom_course_type,
          })
        })
      }

      sessionStorage.setItem('editClassList', JSON.stringify(newData));

      this.$router.push({
        path: '/goods/editClass',
        query: {
          id: _id,
          add
        }
      })
      return;

      this.course_id = course_id

      this.visible = true;

      this.courseId = id;

      this.subjectId = null;

      this.courseForm = {
        id,
        course_id: null,
        structure_id: null,
        subject_id: null,
        sort,
      };

      this.subjectList = [];

      this.structureList = [];

      this.courseData = {};

      this.currCourseName = '';

      this.isCheck = null;

      this.$http.get("/course/index_before").then(res => {
        this.subjectList = res.subjects;
      });
    },

    getStructure(id) {
      this.structureList = [];

      this.courseData = {};

      this.currCourseName = "";

      this.isCheck = null;

      this.courseForm = {
        ...this.courseForm,
        course_id: null,
        structure_id: null,
        subject_id: id
      };

      const subject = this.subjectList.find(item => item.id === id);

      if (subject) {
        this.structureList = subject.structure;
      }
    },

    selectStructure(data) {
      if (data.leaf) return;

      this.courseForm = {
        ...this.courseForm,
        course_id: null,
        structure_id: data.id
      };

      this.isCheck = null;

      this.currCourseName = data.name;

      this.structureId = data.id;

      this.current_size = 10;

      this.current_page = 1;

      this.likeName = ''

      this.getCourseData();
    },

    onSizeChange(per_page) {
      this.current_size = per_page;

      this.current_page = 1;

      this.getCourseData();
    },

    onCurrentChange(page) {
      this.current_page = page;

      this.getCourseData();
    },

    getCourseData() {
      const url = `/api/imkid/course/?page=${this.current_page}&per_page=${
        this.current_size
      }&equal[structure_id]=${this.structureId}&like[name]=${this.likeName}`;

      this.$http.get(url).then(res => {
        this.courseData = res;
        this.courseData.data.forEach(element => {
          element["currentSelectRecordId"] = 0;
        });
      });
    },

    submitEdition(submit) {
      submit().then(() => this.updateCourseList());
    },

    updateCourseList() {
      this.courseForm.schedule_video_id = this.selectRecordId || "";
      this.courseForm.recording_list_id =  this.local.recording_list_id || "";
      if(this.selectRecordId){
        this.courseForm.type = 2
      } else if(this.local.recording_list_id){
         this.courseForm.type = 3
      } else{
        this.courseForm.type = 1
      }
      this.$http
        .post(`/curriculum/course/${this.courseId}`, this.courseForm)
        .then(() => this.getCourseList());
    },

    checkCourse(item, index) {
      this.isCheck = item.id;
      this.courseForm = {
        ...this.courseForm,
        course_id: item.id
      };
      this.curCourseRecordIndex = index;
    },

    //选择录播课
    chooseRecord(item) {
      this.local={}
      this.curCourseId = item.id;
      this.visibleRecord = true;
    },
     //选择录播课
    chooseLocal(item) {
      this.selectRecordId = ''
      this.curCourseId = item.id;
      this.visibleLocal = true;
    },

    handleSelectionChange(val) {
      console.log(val)
    },

    //提交选择的录播课
    submitRecord() {
      if(!this.selectRecordId){
        this.$message.error("请选择录播课");
        return;
      }
      this.local={}
      this.visibleRecord = false;
      for (let i = 0; i < this.courseData.data.length; i++) {
        if (this.courseForm.course_id == this.courseData.data[i].id) {
          this.courseData.data[i].selectRecordId = this.selectRecordId;
          let temp = this.courseData.data[i];
          this.$set(this.courseData.data, i, temp);
        }
      }
    },

    //取消选择的录播课
    cancelRecord(){
      this.courseData.data[
          this.curCourseRecordIndex
        ].currentSelectRecordId = '';
        let temp = this.courseData.data[this.curCourseRecordIndex];
        this.$set(this.courseData.data, this.curCourseRecordIndex, temp);
        this.visibleRecord = false;
    },

    // 批量移动
    moreMove () {
      const arr = [];

      this.formData.content.forEach(val => {
        if (val.check) {
          arr.push(val.ids);
        }
      });

      if (arr.length) {
        this.moves.form = [{
          attr: 'cascader',
          name: '课时分类',
          width: '80px',
          options: this.typeSelectDataMe[0].childrens,
          props: {
            rules: {
              message: '请选择课时',
              required: true,
              target: 'blur'
            }
          },
          type: 'cascader',
          value: ''
        }];

        this.moves.data = arr;
        this.moves.show = true;
      } else {
        this.$message.error('您还未选中');
      }
    },
    onMovesForm (valid, data) {
      this.moves.isSubmit = false;

      if (valid) {
        const category_ids = [data.model_cascader[data.model_cascader.length - 1]];
        const _data = [];
        const _obj = {};

        this.moves.data.forEach(id => {
          _data.push({
            id,
            category_ids,
          });
        });

        _obj.data = _data;

        this.$http.patch('api/course/commodities/courses/category_ids', _obj).then(() => {
          this.moves.show = false;
          this.$message.success('移动成功');
          this.getCourseList(this.updateFormData);
        });
      }
    },

    onTypeSelectLoop (children) {
      for (var i = 0; i < children.length; i++) {
        var ci = children[i];

        if (this.cacheId === ci.id) {
          this.cacheSelect = ci;
          break;
        }

        if (ci.recursive_children && ci.recursive_children.length) {
          this.onTypeSelectLoop(ci.recursive_children);
        }
      }
    },

    onTypeIdsLoop (children) {
      for (var i = 0; i < children.length; i++) {
        var ci = children[i];

        this.cacheIds.push(ci.id);

        if (ci.recursive_children && ci.recursive_children.length) {
          this.onTypeIdsLoop(ci.recursive_children);
        }
      }
    },

    onTypeSelect (val, list) {
      if (val.id) {
        this.cacheId = val.id;
        this.cacheIds = [];

        this.onTypeSelectLoop(list);
        this.cacheIds.push(this.cacheSelect.id);
        this.cacheSelect.recursive_children && this.cacheSelect.recursive_children.length && this.onTypeIdsLoop(this.cacheSelect.recursive_children);

        this.formData.content.forEach(item => {
          if (item.category_ids && this.cacheIds.some(val => item.category_ids.includes(val))) {
            item.hide = false;
          } else {
            item.hide = true;
          }

          item.check && (item.check = false);
        });

        this.$set(this.formData, 'content', this.formData.content);
      } else {
        this.formData.content.forEach(item => {
          item.hide = false;
        });
      }

      this.updateFormData();
    },

    updateFormData () {
      this.formData.show = false;

      this.$nextTick(() => {
        this.formData.show = true;
      });
    }
  },
};
</script>

<template>
  <div class="curriculum-period" v-loading="loading">
    <header>
      <!-- <h2 class="curriculum-period-header__title">课时管理</h2> -->

      <div class="curriculum-period-header__block">
        <p>商品名称： {{ formData.name }}</p>
        <p>商品简介： {{ formData.introduction }}</p>
        <p>商品类型： {{ formData.category }}</p>
        <p>课时数： &nbsp;&nbsp;&nbsp;{{ formData.course_count }}</p>
      </div>
    </header>

    <el-row>

      <div
        style="float: left;line-height: 32px; color: #303133;"
      >课时分类: &nbsp;</div>
      <TypeSelect
        type="commodity_course_category"
        :rootCatalog="'课时分类'"
        :rootTitle="'课时内容分类编辑'"
        :data.sync="typeSelectDataMe"
        :hasSelectData="true"
        :selectData="typeSelectData"
        @onTypeSelect="onTypeSelect"
      />

      <el-button class="selecte-move" @click="moreMove" size="small">批量移动</el-button>
    </el-row>

    <div
      v-loading.lock="formData.loading"
      v-if="checkPermission('course_index') && formData.show"
      class="curriculum-period-body"
    >
      <Draggable :value="formData.content" @end.stop="dragCourseware">
        <div
          v-for="(item,index) in formData.content"
          :key="index"
          class="curriculum-item"
          :class="{'curriculum-hide': item.hide}"
        >
          <div class="curriculum-period-body__block">
            <span class="curriculum-span">{{ index + 1 }}</span>
            <!-- <div v-if="item.type==1"> -->
            <div>
              <p class="curriculum-period-body__title">{{ item.name }}</p>
              <p>{{ item.sales_status_up_at || item.updated_at }}</p>
              <!-- <p>课件数：{{ item.ware_number }}</p> -->
              <!-- <p>游戏数：{{ item.game_number }}</p> -->
            </div>
            <!-- <div v-else-if="item.type==2">
              <p class="curriculum-period-body__title">录播课</p>
              <p class="curriculum-period-body__title">{{ item.name }}</p>
              <a class="curriculum-period-body__url" id="curriculum-period-body__url" @click="videoUrl($event)" :href="item.video_url" target="_blank">预览视频</a>
              <p></p>
            </div>
            <div v-else>
              <p class="curriculum-period-body__title">本地化</p>
              <p class="curriculum-period-body__title">{{ item.name }}</p>
              <a class="curriculum-period-body__url" id="curriculum-period-body__url" @click="videoUrl($event)" :href="item.video_url" target="_blank">预览视频</a>
              <p></p>
            </div> -->
            <i
              v-if="checkPermission('course_delete')"
              class="el-icon-delete"
              @click.stop="delCourse(item.id)"
              title="删除"
            />
            <i v-else class="curriculum-period-body__display"/>

            <i
              class="el-icon-edit-outline"
              title="编辑"
              @click.stop="updateCourse(false, item.id)"
            />

            <el-checkbox class="select-check" v-model="item.check"></el-checkbox>
          </div>
        </div>
        <div class="curriculum-period-body__empty" @click="updateCourse(true)">
          <!-- <span>{{ index + 1 }}</span> -->
          <i class="el-icon-plus"/>
        </div>
      </Draggable>
    </div>

    <AppFormDialog
      ref="courseDialog"
      :visible.sync="visible"
      :rules="courseRules"
      :model="courseForm"
      object="选择课时"
      width="1000px"
      label-width="1px"
      @on-submit="submitEdition"
    >
      <el-form-item label=" " prop="course_id">
        <el-select
          v-model="subjectId"
          placeholder="请选择学科"
          style="margin-bottom: 20px;"
          @change="getStructure(subjectId)"
        >
          <el-option
            v-for="item in subjectList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          />
        </el-select>
         <el-input v-model="likeName" class="input" placeholder="请输入"></el-input>
       <el-button class="submint-btn" type="primary" @click="selectSubject">查询</el-button>

        <div class="curriculum-period__content">
          <el-tree
            ref="tree"
            :props="treeProps"
            :data="structureList"
            highlight-current
            node-key="id"
            children="leaf"
            empty-text
            class="curriculum-period__course"
            @node-click="selectStructure"
          />

          <div class="curriculum-period__info choiceLocal">
            <span class="curriculum-period-title">{{ currCourseName }}</span>
            <hr>
            <div class="curriculum-period-info__block" style="display:flex;flex-wrap:wrap;">
              <div
                v-for="(item,index) in courseData.data"
                :key="item.id"
                class="curriculum-period-info__course"
                @click="checkCourse(item,index)"
              >
                <div class="curriculum-period-info__course__title">{{ item.name }}</div>
                <p>课件数：{{ item.ware_number }}</p>
                <p>游戏数：{{ item.game_number }}</p>
                <span v-if="isCheck === item.id" class="curriculum-period-info__check">
                  <i class="el-icon-check"/>
                </span>
                <el-button
                size="small"
                  @click="chooseRecord(item)"
                >选择录播课</el-button>
                <el-button
                size="small"
                style="margin-left:0"
                @click="chooseLocal(item)"
                >选择本地化</el-button>
              </div>
            </div>

            <footer class="curriculum-period-footer">
              <el-pagination
                v-if="courseData.last_page > 1"
                :current-page="current_page"
                :page-sizes="[10, 20]"
                :page-size="current_size"
                :total="courseData.total"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="onSizeChange"
                @current-change="onCurrentChange"
              />
            </footer>
          </div>
        </div>
      </el-form-item>
    </AppFormDialog>
    <el-dialog title="本地化" :visible.sync="visibleLocal" width="80%" center>
      <hr>

      <AppList
        v-if="visibleLocal"
        ref="list"
        :list.sync="list"
        class="video-list"
        :api="`/course/${curCourseId}/recording?equal[status]=1`"
        title="本地化列表"
      >
        <template slot-scope="props">

          <el-table :data="props.listData" @selection-change="handleSelectionChange">
            <el-table-column label="请选择">
              <template slot-scope="scope">
                <el-radio v-model="selectLocalId" @change="choiceRadio" :label="scope.row.id">&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column
              v-for="column in columnsLocal"
              :key="column.prop"
              :prop="column.prop"
              :label="column.label"
              :width="column.prop=='url'?'240px':''"
            />
            <el-table-column label="时间段">
            <template slot-scope="scope">
              <span
                v-if="scope.row.start_time"
              >{{scope.row.start_time}}~{{scope.row.end_time}}</span>
            </template>
          </el-table-column>
          </el-table>

        </template>
      </AppList>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="cancelLocal">取 消</el-button>
        <el-button type="primary" @click="submitLocal">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="录播课" :visible.sync="visibleRecord" width="60%" center>
      <hr>

      <AppList
        v-if="visibleRecord"
        ref="list"
        :list.sync="list"
        class="video-list"
        :api="`/schedule_video/index_video?equal[course_id]=${curCourseId}`"
        title="录播内容"
      >
        <template slot-scope="props">

          <el-table :data="props.listData" @selection-change="handleSelectionChange">
            <el-table-column label="请选择">
              <template slot-scope="scope">
                <el-radio v-model="selectRecordId" :label="scope.row.id">&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column
              v-for="column in columnsRecord"
              :key="column.prop"
              :prop="column.prop"
              :label="column.label"
              :width="column.prop=='url'?'240px':''"
            />
          </el-table>

        </template>
      </AppList>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelRecord">取 消</el-button>
        <el-button type="primary" @click="submitRecord">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="移动"
      width="460px"
      :visible.sync="moves.show"
    >
      <EleForm
        ref="movesForm"
        :form="moves.form"
        :is-submit="moves.isSubmit"
        @onAttr="onMovesForm"
      ></EleForm>

      <span slot="footer" class="dialog-footer">
        <el-button @click="moves.show = false">取 消</el-button>
        <el-button type="primary" @click="moves.isSubmit = true">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="postcss">
.record_table {
  position: absolute;
  top: 10%;
  left: 20%;
  width: 60%;
  background-color: rgba(0, 0, 0, 0.4);
}
.curriculum-period-header__title {
  font-size: 1rem;
  margin-bottom: 30px;
}

.curriculum-hide {
  display: none !important;
}
.curriculum-item,
.curriculum-period-body__empty {
  display: inline-block;
  cursor: pointer;
  text-align: center;
  width: 150px;
  height: 150px;
  background: #e1e1e1;
  margin: 20px 20px 0 0;
  position: relative;
}
.curriculum-item {
  cursor: grab;
  display: inline-block;
  vertical-align: middle;

  & .el-icon-delete,
  & .el-icon-edit-outline {
    cursor: default;
    font-size: 23px;
  }
}
.curriculum-span {
  display: inline-block;
  background: #f0f0f0;
  width: 25px;
  line-height: 25px;
  border-radius: 50%;
  position: absolute;
  top: 5px;
  left: 5px;
}
.curriculum-period-body__display {
  display: inline-block;
  width: 23px;
  height: 21px;
}

.curriculum-period-body__title {
  width: 130px;
  text-align: center;
  padding-left: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.curriculum-period-body__empty {
  vertical-align: bottom;
  & .el-icon-plus {
    font-size: 23px;
    position: absolute;
    left: 60px;
    top: 65px;
  }
}

.curriculum-period__content {
  display: flex;
  margin-bottom: 20px;
}

.curriculum-period__course {
  width: 25%;
  flex-shrink: 0;
  border-right: 1px solid rgba(232, 237, 250);
}

.curriculum-period__info {
  width: 72%;
  margin-left: 20px;
}

.curriculum-period-info__block > div {
  display: inline-block;
  cursor: pointer;
  text-align: center;
  width: 150px;
  height: 150px;
  background: #e1e1e1;
  margin: 20px 20px 0 0;
  position: relative;
}
.choiceLocal .curriculum-period-info__block > div{
  height: 180px !important;
}

.curriculum-period-info__course__title {
  margin-top: 5px;
  line-height: 20px;
}

.curriculum-period-info__course > p {
  margin: 0;
  line-height: 30px;
}

.curriculum-period-footer {
  margin-top: 20px;
}

.curriculum-period-info__check {
  background: #818181;
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  line-height: 38px;
  position: absolute;
  right: 10px;
  bottom: 10px;
  & .el-icon-check {
    font-size: 23px;
    color: white;
  }
}
.input{
  margin-left: 50px;
  width: 260px;
  margin-right: 20px;
}

.selecte-move {
  float: right;
}
.select-check {
  position: absolute;
  bottom: 9px;
  right: 10px;
  height: 23px;
  overflow: hidden;

  & .el-checkbox__inner {
    width: 23px;
    height: 23px;
    cursor: default;

      &:after {
         height: 10px;
         left: 9px;
         top: 4px;
       }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Goods/goodsManageClass.vue